import { buildMode } from "./environment";

let _rootUrl = "https://testapi.kymdanstore.vn/apis/";
let _s2bpay =
  "https://test-s2bpay.sc.com/s2bpaysit/resources/merchant/js/s2bpay.js";
let _dataCorpid = "VNKYMDAN";
let _urlOriginal = "https://testapi.kymdanstore.vn/";

switch (buildMode) {
  case "production":
    _rootUrl = "https://api.kymdanstore.vn/apis/";
    _s2bpay = "https://s2bpay.sc.com/s2bpay/resources/merchant/js/s2bpay.js";
    _dataCorpid = "VN05425A";
    break;
  case "staging":
    _rootUrl = "https://testapi.kymdanstore.vn/apis/";
    break;
  default:
    _rootUrl = "https://testapi.kymdanstore.vn/apis/";
    _urlOriginal = "https://testapi.kymdanstore.vn/";
    _s2bpay =
      "https://test-s2bpay.sc.com/s2bpaysit/resources/merchant/js/s2bpay.js";
    break;
}

export const rootUrl = _rootUrl;
export const s2bpay = _s2bpay;
export const dataCorpid = _dataCorpid;
export const urlOriginal = _urlOriginal;
